import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

interface OwnProps {
    className?: string;
    slides?: number;
    start?: number;
    infinite?: boolean;
}

export const SimpleSlider = ({className, children, slides, start, infinite}: React.PropsWithChildren<OwnProps>) => {
    const settings = {
        arrows: false,
        dots: true,
        infinite: infinite ?? (Array.isArray(children) && children.length > 1),
        speed: 500,
        slidesToShow: slides ?? 1,
        slidesToScroll: slides ?? 1,
    };

    return (
        <Slider className={className} initialSlide={start ?? 0} {...settings}>
            {children}
        </Slider>
    );
};
